import React from 'react'
import styled from '@emotion/styled'

import Accordion from '../generic/Accordion'
import FAQs from './steps/FaqSections'

import { fontSizeXLarge, fontSizeSmall, fontSizeXSmall, fontSize2XSmall, fontWeightRegular, fontWeightBold, grayLight45 } from '../../constants/principles'
import { breakpoints } from '../../constants'

export default ({ isDesktop, inline }) => {
  const sections = FAQs()
  return (
    <FAQDiv inline={inline}>
      {inline && <StyledH2>Frequently Asked Questions</StyledH2>}
      <StyledSection>
        {sections.map((section, i) => (
          <Accordion key={i} title={section.text} expanded={false} fontSize={isDesktop ? fontSizeSmall : fontSizeXSmall} border={true}>
            {section.items.map((question, i) => (
              <Accordion key={i} title={question.text} expanded={false} fontSize={fontSize2XSmall}>
                <AnswerDiv>
                  {question.subText && <StyledAnswer bold={false}>{question.subText}</StyledAnswer>}
                  {question.subList && (
                    <StyledUl>
                      {question.subList.map((listItem, i) => (
                        <StyledLi key={i}>
                          {listItem.heading && <ListItemHeader>{listItem.heading}</ListItemHeader>}
                          {listItem.detail && <ListItemDetail>{listItem.detail}</ListItemDetail>}
                        </StyledLi>
                      ))}
                    </StyledUl>
                  )}
                </AnswerDiv>
              </Accordion>
            ))}
          </Accordion>
        ))}
      </StyledSection>
    </FAQDiv>
  )
}
const FAQDiv = styled.div`
  ${p => !p.inline && `padding: 0; width: 100%;`}

  ${p => p.inline && `padding: 24px 16px; width: 95%; background-color: ${grayLight45};`}
    @media (min-width: ${breakpoints.lg}px) {
     ${p => p.inline && `padding: 40px 24px; width: 65%; background-color: ${grayLight45};`}
  }
  display: flex;
  flex-direction: column;
  align-items: left;
  margin-bottom: ${p => (p.inline ? 40 : 0)}px;
  max-width: 1024px;
`

const AnswerDiv = styled.div`
  font-weight: ${fontWeightRegular};
`

const StyledH2 = styled.h2`
  font-size: ${fontSizeSmall};
  font-weight: inherit;
  line-height: 30px;

  @media (min-width: ${breakpoints.lg}px) {
    font-size: ${p => fontSizeXLarge};
    line-height: 40px;
  }
  margin: 0 0 8px 0;
  text-align: center;
`

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 100%;
`

const StyledAnswer = styled.div`
  padding-top: 8px;
  font-size: ${fontSize2XSmall};
  font-weight: ${p => (p.bold ? fontWeightBold : fontWeightRegular)};
`

const StyledUl = styled.ul`
  list-style-type: disc;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 32px;
  margin-top: 8px;
`

const StyledLi = styled.li`
  font-weight: normal;
  width: 100%;
  text-align: left;
`

const ListItemHeader = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: bold;
  padding-top: 8px;
`

const ListItemDetail = styled.div`
  font-size: ${fontSize2XSmall};
`
